export function getTemplateGenerationStatus(template) {
  const json = template?.value_json;
  if (!json) return null;
  if (typeof json === "string") {
    try {
      return JSON.parse(json)?.status ?? null;
    } catch {
      return null;
    }
  }
  return json.status ?? null;
}

export function isTemplateGenerating(template) {
  return getTemplateGenerationStatus(template) === "generating";
}

export function isTemplateGenerationFailed(template) {
  return getTemplateGenerationStatus(template) === "failed";
}
